/**
 * 内容详情页公用方法：跳转等
 */
import { isArray } from "lodash"
import { CONTENT_TYPES } from "../../store/enums"
import { PAGE_VIEW, CLICK, ANALYSE } from "@constants/report-dictonary"
import { SERVICEZONE_GOODS } from "@constants/pf-structure"
import * as reportDict from "../../constants/report-dictonary"
import { isLOLPcGame } from "../../business/lolPc"
import * as gameProps from "../../api/gameProps"
import * as helper from "../../utils/helper"

export default function (root) {
  const { $route, $router, $store, $nextTick } = root

  let maxSeq = -1

  /**
   * 判断媒体类型
   */
  const isType = (content, types) => {
    let currentContentType = content.contentType

    if (isArray(types)) {
      return types.indexOf(currentContentType * 1) > -1
    }

    return currentContentType * 1 === types
  }

  /**
   * 跳转到图文的详情页
   */
  const goToContentDetail = ({ content, contentType, iformat, pfStructure, queryExt, shelfConfig, resultInfo = {} }) => {
    switch (contentType) {
      case CONTENT_TYPES.imageText:
        $router.push({
          name: "mallImageText",
          params: {
            contentId: content.contentId
          },
          query: {
            ...queryExt,
            pfStructure: pfStructure || SERVICEZONE_GOODS
          }
        })
        break

      case CONTENT_TYPES.longVideo:
      case CONTENT_TYPES.shortVideo:
        $router.push({
          name: "mallShortVideo",
          params: {
            contentId: content.contentId
          },
          query: {
            ...queryExt,
            pfStructure: pfStructure || SERVICEZONE_GOODS
          }
        })
        break

      // 自定义跳转运营位
      case CONTENT_TYPES.redirect:
        goToRedirect({ content, iformat, pfStructure, shelfConfig })
        break
    }

    $store.dispatch("reportUserAction", getReportClickParams({ data: content, iformat, pfStructure, resultInfo }))
  }

  const goToRedirect = ({ content, iformat, pfStructure, shelfConfig }) => {
    let redirectUrl = content.generalView.redirectUrl

    if (redirectUrl) {
      cacheState({ shelfConfig })

      $store.dispatch("reportAndJump", {
        target: redirectUrl,
        ...getReportClickParams({ data: content, iformat, pfStructure })
      })

      return
    } else {
      $store.dispatch("reportUserAction", {
        iformat: ANALYSE.SERVICEZONE_REDIRECT_CARD_ERROR,
        resultInfo: {
          contentId: content.contentId
        }
      })
    }
  }

  const cacheState = ({ shelfConfig }) => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

    sessionStorage.setItem(
      "news_shelf_info",
      JSON.stringify({
        scrollTop,
        shelfConfig: shelfConfig
      })
    )
  }

  /**
   * 获取点击物品时需要上报的参数
   * @param data
   * @returns {{pfStructure: string, iformat: string, resultInfo: {type: *, contentId}}}
   */
  const getReportClickParams = ({ data, iformat, pfStructure, resultInfo = {} }) => {
    return {
      iformat: iformat,
      pfStructure: pfStructure,
      resultInfo: {
        type: data.contentType,
        contentId: data.contentId,
        ...resultInfo
      }
    }
  }

  /**
   * 前往道具详情页
   * @param {*} prop
   */
  const goToPropDetail = ({
    prop,
    pfStructure = "",
    reportIformat = "",
    extendObj = {},
    routeQuery = "",
    resultInfo = {},
    reportPfStructure = ""
  }) => {
    let groupId = (extendObj && extendObj.bizgroupid) || $route.params.bizgroupid
    let bizid = (extendObj && extendObj.bizid) || $route.params.bizid
    let amsid = (prop.itemExtend && prop.itemExtend.AMSID) || ""

    $router.push({
      path: `/detail/${groupId}/biz/${bizid}/goods/${amsid}`,
      query: {
        pfStructure: pfStructure,
        ...routeQuery
      }
    })
    if (reportIformat) {
      $store.dispatch("reportUserAction", {
        iformat: reportIformat,
        pfStructure: reportPfStructure || "",
        resultInfo: {
          ...resultInfo,
          busId: `${groupId}_${bizid}`,
          productId: amsid
        }
      })
    }
  }

  /**
   * 跳转道具详情页
   * @param {*} prop
   */
  const redirectPropDetail = ({
    prop,
    pfStructure = "",
    reportIformat = "",
    extendObj = {},
    routeQuery = "",
    resultInfo = {},
    reportPfStructure = ""
  }) => {
    if (gameProps.isExperienceCard(prop) && gameProps.checkCardActivityValid(prop)) {
      // 如果是体验卡的话，需要跳转到对应的道具详情页
      prop = $store.getters.vmallConfigByItemID[prop.itemExtend.LinkID]
    }
    if (gameProps.isOutLinkGoods(prop)) {
      // 如果外链道具配置的是商店内路由
      if (helper.checkIfIsInnerUrl(prop.itemExtend.Link)) {
        //   如果是商店内部地址
        let hash = helper.getInnerRouterHash(prop.itemExtend.Link)

        if (hash) {
          $router.push({
            path: hash,
            query: {
              pfStructure: pfStructure
            }
          })

          $store.dispatch("reportUserAction", {
            iformat: reportIformat ? reportIformat : `${reportDict.CLICK.SERVICEZONE_GOODS_LIST}`,
            pfStructure: pfStructure,
            resultInfo: resultInfo
          })
        }
      } else {
        // 如果是外链物品，上报并跳转
        $store.dispatch("reportAndJump", {
          target: prop.itemExtend.Link,
          iformat: reportIformat ? reportIformat : `${reportDict.CLICK.SERVICEZONE_GOODS_LIST}`,
          resultInfo: {
            productId: prop.itemExtend.AMSID,
            busId: `${$route.params.bizgroupid}_${$route.params.bizid}`
          }
        })
      }

      return
    }

    let groupId = (extendObj && extendObj.bizgroupid) || $route.params.bizgroupid
    let bizid = (extendObj && extendObj.bizid) || $route.params.bizid
    let goodsId = (prop.itemExtend && prop.itemExtend.AMSID) || ""

    // 当前仅针对 LOL 使用 goodsId
    if (isLOLPcGame($store.getters.currentItem.busId)) {
      goodsId = prop.goodsId || ""
    }

    $router.push({
      path: `/detail/${groupId}/biz/${bizid}/goods/${goodsId}`,
      query: {
        pfStructure: pfStructure,
        ...routeQuery
      }
    })
    if (reportIformat) {
      $store.dispatch("reportUserAction", {
        iformat: reportIformat,
        pfStructure: reportPfStructure || "",
        resultInfo: {
          ...resultInfo,
          busId: `${groupId}_${bizid}`,
          productId: goodsId
        }
      })
    }
  }

  /**
   * 专区切换 Tab 使用
   * @param {*} linkTabId
   */
  const goToOtherTab = linkTabId => {
    let linkTabIndex = 0
    try {
      // 切换tab后，让tab移动到可见范围内
      $store.getters.currentItemShelfTabList.forEach((tabShelfItem, index) => {
        if (tabShelfItem.itemId == linkTabId) {
          linkTabIndex = index
        }
      })
      document.getElementById("serviceZoneTab").scrollLeft = document.getElementById("serviceZoneTabItem" + linkTabIndex).offsetLeft - 110
    } catch (error) {
      console.log(error)
    }
    $router.push({
      path: $route.path,
      query: {
        ...$route.query,
        zoneTabId: linkTabId,
        pfStructure: "zoneHome"
      }
    })

    $store.dispatch("reportUserAction", {
      iformat: `${CLICK.SERVICEZONE_MORE_INNERTAB}`,
      resultInfo: { zoneTabIndex: linkTabIndex, linkTabId }
    })
  }

  const getCachedInfo = () => {
    return new Promise(resolve => {
      try {
        let session = sessionStorage.getItem("news_shelf_info")

        if (!session) {
          resolve()
          return
        }

        session = JSON.parse(session)

        let { scrollTop, shelfConfig } = session

        if (!shelfConfig || !shelfConfig.pageIndex) {
          resolve()
          return
        }

        $nextTick(() => {
          window.scrollTo(0, scrollTop * 1)
        })

        sessionStorage.removeItem("news_shelf_info")

        resolve(shelfConfig)
      } catch (e) {
        resolve()
      }
    })
  }

  const itemViewsObserver = () => {
    let scrollItemObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          let contentId = entry.target.dataset.contentId
          let seq = entry.target.dataset.seq
          let shelfStyle = entry.target.dataset.shelfStyle
          // 如果在可视化的区域内，则需要上报且若是通栏则需要初始化视频
          // 列表型资讯需要判断 parseInt(seq) > maxSeq，防止用户上下滑动导致重复上报
          // 如果是货架型资讯，因为可以换页，所以只有第一页走这个监听上报
          if (contentId && entry.isIntersecting && parseInt(seq) > maxSeq) {
            maxSeq = parseInt(seq)

            $store.dispatch("reportUserAction", {
              // 货架型资讯单个曝光 ： 列表型资讯单个曝光
              iformat: shelfStyle ? PAGE_VIEW.SERVICEZONE_NEWS_SHELF_SINGLE : PAGE_VIEW.SERVICEZONE_NEWS_LIST_SINGLE,
              pfStructure: $route.query.pfStructure,
              resultInfo: {
                contentId: contentId,
                type: entry.target.dataset.contentType,
                index: seq
              }
            })
          }
        })
      },
      {
        threshold: [0.7]
      }
    )
    return scrollItemObserver
  }

  return {
    isType,
    goToContentDetail,
    getReportClickParams,
    goToPropDetail,
    goToOtherTab,
    goToRedirect,
    cacheState,
    getCachedInfo,
    itemViewsObserver,
    redirectPropDetail
  }
}
